<template>
	<search-list ref="sl" :pageSizes="[25,30,40]" apiPath="/advertiser/list" :where="where" :order="order" :searchKeys="searchKeys">
		<mm-lc title="Adv Status">
			<mm-adv-status v-model="where.status" multiple/>
		</mm-lc>
		<mm-lc title="Account Level">
			<mm-adv-accountlevel v-model="where.account_level" multiple />
		</mm-lc>
		<mm-lc title="Geo">
			<mm-offer-geos v-model="where.geo" multiple />
		</mm-lc>
		<mm-lc title="Account Manager">
			<mm-users v-model="where.account_manager" multiple></mm-users>
		</mm-lc>
		<mm-lc title="Business Manager">
			<mm-users v-model="where.business_manager" multiple></mm-users>
		</mm-lc>
		<mm-lc title="Auth Manager" v-show="is_show_auth">
			<mm-users v-model="where.auth_manager" multiple :showMoreOptions="false" not_admin></mm-users>
		</mm-lc>
		<mm-lc title="Is Api">
			<el-switch v-model="where.is_api" :active-value="1"></el-switch>
		</mm-lc>
		<mm-lc title="IO Signed">
			<mm-tf-select v-model="where.sign_io" />
		</mm-lc>
		<mm-lc title="Track Platform">
			<mm-adv-track-platform v-model="where.track_platform" />
		</mm-lc>
		<el-button slot="actions" type="success" class="el-icon-document-add" @click="createAdv"></el-button>
		<div slot="actions" />
			<mm-table slot="dataTable" slot-scope="res" :res="res" @sort-change="sortChange">
			<el-table-column label="Adv Id" prop="adv_id" />
			<el-table-column label="Adv name" prop="adv_name">
				<mm-get-detail slot-scope="sp" :row_name="sp.row.adv_name" :row_id="sp.row.adv_id" row_type="adv" />
			</el-table-column>
			<el-table-column label="Geo" prop="geo"/>
			<el-table-column label="Type" prop="adv_type" :formatter="(row,column,v)=>`${v.slice(0,3).toUpperCase()}`" />
			<el-table-column label="Account Level" prop="account_level" :formatter="(row,column,v)=>`Level ${v.toUpperCase()}`" />
			<el-table-column label="Weight" prop="weight" sortable="custom"/>
			<el-table-column label="IO" prop="sign_io" sortable="custom">
				<span slot-scope="sp" :class="'status-'+(sp.row.sign_io ? 'active' : 'close')">{{sp.row.sign_io ? 'SIGNED' : 'UNSIGN'}}</span>
			</el-table-column>
			<el-table-column label="Account Manager" prop="account_manager" />
			<el-table-column label="Business Manager" prop="business_manager" />
			<el-table-column label="status" prop="status">
				<span slot-scope="sp" :class="'status-'+sp.row.status">{{sp.row.status.toUpperCase()}}</span>
			</el-table-column>
			<el-table-column label="action">
				<template slot-scope="sp">
					<el-dropdown szie="small" trigger="click">
						<el-button type="primary" plain size="mini">Action</el-button>
						<el-dropdown-menu slot="dropdown" >
							<el-dropdown-item @click.native="edit(sp.row)">Edit</el-dropdown-item>
							<el-dropdown-item @click.native="editRule(sp.row)">Edit Rule</el-dropdown-item>
							<el-dropdown-item @click.native="toS2S(sp.row)">To S2S</el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown>
				</template>

			</el-table-column>

		</mm-table>

	</search-list>
</template>

<script>
import advTrackPlatform from '../components/adv/advTrackPlatform.vue';
export default {
	components: { advTrackPlatform },
	data() {
		const searchKeys = {
			adv_name: { label: "Adv Name", fuzzy: true },
			adv_id: { label: "Adv Id" },
			billing_info: { label: "Billing Info", fuzzy: true },
			token: { label: "Token" },
		};
		const user_info = this.$utils.getCookies(['group_name']);
		const is_show_auth = (user_info.group_name === 'admin');
		return {
			searchKeys,
			where: {
				is_api: 0,
				business_manager: "",
				account_manager: "",
				account_level: "",
				status: "",
				geo: "",
			},
			order:[],
			is_show_auth,
		};
	},
	methods: {
		createAdv() {
			window.open('/advCreate');
		},
		edit(row){
			window.open('/advEdit?id='+row.adv_id);
			
		},
		async toS2S(row) {
			this.$confirm('add S2S?', 'Tips', {
				confirmButtonText: 'Yes',
				cancelButtonText: 'No',
				type: 'warning'
			}).then(async () => {
				await this.$post('/advertiser/toS2S', { adv_id: row.adv_id });
				await this.$refs.sl.refresh();
			}).catch(() => {});
		},
		editRule(row){
			window.open('/advRuleEdit?id='+row.adv_id);
		},
		getDetail(adv_id) {
			this.rootGetDetail(adv_id,true);
		},
		async sortChange(column){
			const order = this.order;
			order.splice(0, order.length);
			if(column.order == 'ascending'){
				// order.field = column.prop;
				// order.order = 'asc';
				order.push([column.prop, 'asc']);
			}else if(column.order == 'descending'){
				order.push([column.prop, 'desc']);
			}else {
				order.push([ 'status', 'asc' ]);
				order.push([ 'updatedAt', 'desc' ]);
			}
			this.order = order;
			await this.$refs.sl.refresh();
		},
	},
	inject: ['rootGetDetail'],

};
</script>

<style scoped>
.bt-create {
  position: relative;
  right: 0px;
}
</style>
